import update from 'immutability-helper';
import { deduplicateArray } from '../languageExtensions/array.js';
import { objectKeys } from '../languageExtensions/object.js';
import 'lodash-unified';

/**
 * Remove extra properties algolia adds to search results, as well as the
 * `algolia` property, which we use to store reshaped data in algolia for
 * indexing purposes.
 */

const stripAlgoliaProperties = hit => {
  const hitExtraKeysObj = {
    _distinctSeqID: true,
    _highlightResult: true,
    _rankingInfo: true,
    _snippetResult: true,
    objectID: true
  };
  const geoExtraKeysObj = {
    _geoloc: true,
    _tags: true,
    _sortingDate: true,
    _writeTimestamp: true,
    objectID: true
  };
  const customExtraKeys = ['algolia' // Used on User in algolia to store reshaped data for indexing
  ];
  const extraKeys = deduplicateArray([...objectKeys(hitExtraKeysObj), ...objectKeys(geoExtraKeysObj), ...customExtraKeys]);
  return update(hit, {
    $unset: extraKeys
  });
};
/** This is the default value used for pagination */

const PAGINATION_HITS_PER_PAGE = 10;

export { PAGINATION_HITS_PER_PAGE, stripAlgoliaProperties };
